import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Box, Typography, Button } from '@mui/material';
import { getUrlWithParams } from '../../utils/Utils';

const PageNotFound = () => {
  const { search } = useLocation();
  const newParams = new URLSearchParams(search);
  const bu = newParams.get('bu');
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate(getUrlWithParams('/home', bu)); // Redirect to the home page
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      height="100vh"
      textAlign="center">
      <Typography variant="h1" component="h2" gutterBottom>
        404
      </Typography>
      <Typography variant="h5" gutterBottom>
        Oops! Page not found.
      </Typography>
      <Button variant="contained" color="primary" onClick={handleGoHome}>
        Go to Home
      </Button>
    </Box>
  );
};

export default PageNotFound;
